export default __webpack_public_path__ + "static/service2-9ad1f6612d24c1d0f3ca858ec435a7f5.png";